import { useContext, useEffect, useState } from 'react'
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  InputAdornment,
  Tooltip,
  IconButton,
} from '@material-ui/core'
import ButtonSp from '../ui/ButtonSp'
import useStyles from './formStyles'
import { useForm, Controller } from 'react-hook-form'
import { Context } from '../../context'
import ControlledAutoComplete from '../ui/ControlledAutoComplete'
import Axios from 'axios'
import {
  boxSizesKeysAndLabels,
  getWlhByBoxSize,
  estimateWeight,
  getBoxSizeByWlh,
} from '../utility/boxSizeUtility'
import CalWeightModal from './CalWeightModal'
import NumberFormat from 'react-number-format'

import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

const DomesticForm = ({
  submitMode,
  setCheckpriceResultList,
  setResultStatus,
  displayMode = 'full', // 'full' | 'bar'
  isActive,
  required = true,
}) => {
  const classes = useStyles()

  const [countriesOptions, setCountriesOptions] = useState([])
  const [weightByVolume, setWeightByVolume] = useState('')
  const [isCalModalOpen, setCalModalOpen] = useState(false)
  const [contextHandled, setContextHandled] = useState(false)

  const { handleSubmit, control, setValue, watch, errors, trigger } = useForm({
    shouldFocusError: false,
  })
  const boxSize = watch('boxSize', 'blankWlh')
  useEffect(() => {
    setWeightByVolume(estimateWeight(getWlhByBoxSize(boxSize)))
  }, [boxSize])

  const { state, dispatch, onRouting } = useContext(Context)

  const { t } = useTranslation('checkprice')
  const Router = useRouter()

  const boxSizesKeysAndLabelsWithUndefined = [
    ...boxSizesKeysAndLabels,
    ['undefined', t('undefined')],
  ]

  const handleFormSubmit = handleSubmit((data) => {
    const parsedWeight = parseInt(data.weight.replace(/\,/g, ''), 10)

    let neoQuery = `typeid=inter&`

    if (data?.toCountry?.value) {
      neoQuery = `${neoQuery}country=${data?.toCountry?.value}&`
    }
    if (parsedWeight) {
      neoQuery = `${neoQuery}weight=${parsedWeight}&`
    }
    if (data?.boxSize) {
      neoQuery = `${neoQuery}size_parcel=${data?.boxSize}`
    }
    // const query = `typeid=inter&country=${data?.toCountry?.value}&weight=${parsedWeight}&size_parcel=${data?.boxSize}`

    const query = neoQuery

    if (submitMode === 'redirect') {
      onRouting('/checkprice', query)
    } else if (submitMode === 'fetch') {
      if (!(parsedWeight && data.toCountry && data.toCountry.value)) return

      onRouting('/checkprice', query, { shallow: true })
      setResultStatus('loading')
      // const calculatedWeightByVolume = estimateWeight(
      //   getWlhByBoxSize(data.boxSize)
      // )
      const wlh = getWlhByBoxSize(data.boxSize)

      Axios.post('/api/checkprice/fetch-inter', {
        // we`ight:
        //   parsedWeight > calculatedWeightByVolume
        //     ? parsedWeight
        //     : calculatedWeightByVolume,`
        weight: parsedWeight,
        width: wlh?.width || 0,
        height: wlh?.height || 0,
        length: wlh?.length || 0,
        country_code: data.toCountry.value,
      })
        .then((res) => {
          setCheckpriceResultList(res.data)
          setResultStatus('success')
        })
        .catch((err) => {
          setCheckpriceResultList([{ error: 'error occur' }])
          setResultStatus('error')
        })
    }
  })

  const handleContext = () => {
    const query = Router.query
    setContextHandled(true)
    const selectedCountry = countriesOptions.find(
      (option) => option.value === query.country
    )
    if (selectedCountry?.label && selectedCountry?.value)
      setValue('toCountry', selectedCountry)
    setValue('weight', query.weight)
    setValue('boxSize', query.size_parcel)
    handleFormSubmit()
  }

  const handleContextOld = () => {
    const query = Router.query
    setContextHandled(true)
    const selectedCountry = countriesOptions.find(
      (option) => option.value === query.country
    )
    if (selectedCountry?.label && selectedCountry?.value)
      setValue('toCountry', selectedCountry)
    setValue('weight', query.weight)
    const preferredBoxSize = getBoxSizeByWlh({
      width: query.width,
      height: query.height,
      length: query.length,
    })
    setValue('boxSize', preferredBoxSize || 'box4')
    handleFormSubmit()
  }

  const showExample = () => {
    const query = Router.query

    let country = {
      label: 'Argentina',
      value: 'AR',
    }

    if (query.country) {
      const selectedCountry = countriesOptions.find(
        (option) => option.value === query.country
      )

      if (selectedCountry?.label && selectedCountry?.value) {
        country = selectedCountry
      }
    }
    setValue('toCountry', {
      ...country,
    })

    setValue('weight', query.weight ? String(query.weight) : '200')
    setValue('boxSize', query.size_parcel ? query.size_parcel : 'ก')
  }

  const loadCountriesOption = async () => {
    try {
      const res = await Axios.get('/api/checkprice/countries?lang=en')
      if ('countries' in res.data) {
        const countriesOptions = res.data.countries.map((country) => {
          return { label: country.text, value: country['alpha_2_code'] }
        })
        setCountriesOptions(countriesOptions)
      } else {
        setCountriesOptions([{ value: '', label: 'An Error Occur' }])
        return 'failed'
      }
      return 'success'
    } catch (err) {
      setCountriesOptions([{ value: '', label: 'An Error Occur' }])
      return 'failed'
    }
  }

  const haveValidQueries = () => {
    const query = Router.query
    if (!query) return false
    const requiredKeys = ['typeid', 'country', 'weight', 'size_parcel']
    const isQueryValid = requiredKeys.every((key) => key in query)
    return isQueryValid
  }

  const haveValidOldQueries = () => {
    const query = Router.query
    if (!query) return false
    const requiredKeys = [
      'typeid',
      'country',
      'weight',
      'width',
      'length',
      'height',
      'dimensionWeight',
    ]
    const isQueryValid = requiredKeys.every((key) => key in query)
    return isQueryValid
  }

  useEffect(() => {
    if (!Router.isReady) return
    if (contextHandled) return
    const onPageStartAsFetchMode = async () => {
      if (submitMode === 'fetch' && haveValidQueries()) {
        handleContext()
      } else if (submitMode === 'fetch' && haveValidOldQueries()) {
        handleContextOld()
      } else if (submitMode === 'fetch') {
        showExample()
      }
    }
    if (countriesOptions.length === 0) loadCountriesOption()
    if (countriesOptions.length > 0) onPageStartAsFetchMode()
  }, [Router.isReady, countriesOptions])

  useEffect(() => {
    const hasError = !!Object.keys(errors)[0]

    if (hasError && Router.pathname === '/') {
      onRouting(
        '/checkprice',
        'typeid=inter&country=AR&weight=200&size_parcel=ก'
      )
    }
  }, [errors])

  // v This area is defining fields
  const renderToCountryField = () => (
    <ControlledAutoComplete
      control={control}
      defaultValue={null}
      label={t('to-country')}
      name="toCountry"
      options={countriesOptions}
      disableClearable
      loading={countriesOptions.length === 0}
      controllerProps={{
        rules: {
          required,
        },
      }}
      textFieldProps={{
        error: errors.toCountry,
        helperText:
          errors.toCountry?.type === 'required' &&
          t('errors.to-country-is-required'),
      }}
    />
  )
  const renderParcelWeightField = () => (
    <Controller
      as={
        <NumberFormat
          customInput={TextField}
          thousandSeparator
          allowNegative={false}
          isNumericString
          // below is props of TextField
          label={t('parcel-weight')}
          type="text"
          variant="outlined"
          fullWidth
          error={errors.weight}
          helperText={errors.weight && t('errors.weight-1-up')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip title={t('estimate-weight')}>
                  <IconButton onClick={() => setCalModalOpen(true)}>
                    <img
                      src="/static/img/calculator_icon.svg"
                      height={25}
                      width={25}
                      alt={t('estimate-weight')}
                    />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          }}
        />
      }
      name="weight"
      defaultValue=""
      rules={{
        required,
        min: 1,
      }}
      control={control}
      key="parcelWeightField"
    />
  )
  const renderParcelSizeField = () => (
    <FormControl variant="outlined" fullWidth>
      <InputLabel error={errors.boxSize}>{t('parcel-size')}</InputLabel>
      <Controller
        as={
          <Select
            variant="outlined"
            label={t('parcel-size')}
            fullWidth
            native
            error={errors.boxSize}
            inputProps={{ 'aria-label': t('parcel-size') }}
          >
            <option aria-label="None" value="" disabled />
            {boxSizesKeysAndLabelsWithUndefined.map(([name, label]) => (
              <option value={name} key={name}>
                {t(label)}
              </option>
            ))}
          </Select>
        }
        control={control}
        name="boxSize"
        defaultValue=""
        rules={{
          required,
        }}
      />
      {errors.boxSize && (
        <FormHelperText error>
          {errors.boxSize?.type === 'required' &&
            t('errors.box-size-is-required')}
        </FormHelperText>
      )}
    </FormControl>
  )
  const renderWeightByVolumeField = () => (
    <NumberFormat
      customInput={TextField}
      thousandSeparator
      isNumericString
      label={t('weight-by-volume')}
      type="text"
      variant="outlined"
      fullWidth
      disabled
      value={weightByVolume}
    />
  )

  const renderFullForm = () => (
    <div className={classes.root}>
      <h3 className={classes.title}>{t('find-a-courier')}</h3>
      <form onSubmit={handleFormSubmit} style={{ width: '100%' }}>
        <Grid container className={classes.gridRoot}>
          <Grid item xs={12} sm={6}>
            {renderToCountryField()}
          </Grid>
          <Grid item xs={12} sm={6}>
            {renderParcelWeightField()}
          </Grid>
          <Grid item xs={12} sm={6}>
            {renderParcelSizeField()}
          </Grid>
          <Grid item xs={12} sm={6}>
            {renderWeightByVolumeField()}
          </Grid>
          {/* <Grid item xs={12} className={classes.noPaddingNoMargin}>
            <ButtonSp
              variant="text"
              onClick={() => setAdvancedOpen(!isAdvancedOpen)}
            >
              {!isAdvancedOpen ? t('advanced') : t('advanced-close')}
            </ButtonSp>
          </Grid> */}
          {/* <Collapse
            in={isAdvancedOpen}
            className={classes.noPaddingNoMargin}
            style={{ width: '100%' }}
          >
            <Grid container className={classes.gridRoot}>
              <Grid item xs={12} sm={6}>
                <Controller
                  as={
                    <DatePicker
                      inputVariant="outlined"
                      label={t('delivery-date')}
                      fullWidth
                      format="LL"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <EventIcon color="disabled" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  }
                  control={control}
                  defaultValue={dayjs()}
                  name="sendDate"
                />
              </Grid>
            </Grid>
          </Collapse> */}
          <Grid container item xs={12} direction="column" alignItems="center">
            <ButtonSp className={classes.submitBtn} type="submit">
              {t('search')}
            </ButtonSp>
          </Grid>
        </Grid>
      </form>
    </div>
  )

  return (
    <div>
      {renderFullForm()}
      <CalWeightModal
        open={isCalModalOpen}
        onClose={() => setCalModalOpen(false)}
        setWeight={(weight) => {
          setValue('weight', weight)
          trigger('weight')
        }}
      />
    </div>
  )
}

export default DomesticForm
